"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SpeakerPresentationControl = require("./SpeakerPresentationControl");
Object.keys(_SpeakerPresentationControl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SpeakerPresentationControl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SpeakerPresentationControl[key];
    }
  });
});